<template>
    <singlebox :post="post" :stat="stat" v-loading="loading" @extendUpdate="updateExtend" :postType="appKey">
        <div class="u-meta u-sub-block" slot="single-header">
            <em class="u-label">类型</em>
            <span class="u-value">{{ post_subtype }}</span>
        </div>

        <!-- 数据字段 -->
        <div class="m-single-meta" v-if="visible">
            <div class="u-subtype-1" v-if="subtype == 1 && data && data.length">
                <div v-for="(feed, i) in data" :key="feed + i">
                    <div class="u-data" v-if="i == 0">
                        <div class="u-feed">
                            <Mark :label="post.author" @click.native="copy(post.author)" />
                        </div>
                        <a
                            class="u-sync"
                            v-if="isAuthor || isEditor"
                            :href="'https://pull.j3cx.com/api/dbm/feed?key=' + post.author + '&_no_cache'"
                            target="_blank"
                            title="默认存在1分钟缓存，如需要即时生效请点击此按钮"
                        >
                            <i class="el-icon-video-play"></i> 云端同步刷新
                        </a>
                        <span class="u-desc">{{ feed.desc }}</span>
                        <a class="u-down el-button el-button--default el-button--small is-plain" :href="feed.file" target="_blank">
                            <i class="el-icon-download"></i>
                            <span>本地下载</span>
                        </a>
                    </div>
                    <div class="u-data" v-if="i != 0 && feed.status">
                        <div class="u-feed">
                            <Mark
                                :label="post.author"
                                :value="feed.name"
                                :BGR="post | highlight"
                                BGL="#24292e"
                                @click.native="copy(post.author + '#' + feed.name)"
                            />
                        </div>
                        <a
                            class="u-sync"
                            v-if="isAuthor || isEditor"
                            :href="'https://pull.j3cx.com/api/dbm/feed?key=' + post.author + '-' + feed.name + '&_no_cache'"
                            target="_blank"
                            title="默认存在1分钟缓存，如需要即时生效请点击此按钮"
                        >
                            <i class="el-icon-video-play"></i> 云端同步刷新
                        </a>
                        <span class="u-desc">{{ feed.desc }}</span>
                        <a class="u-down el-button el-button--default el-button--small is-plain" :href="feed.file" target="_blank">
                            <i class="el-icon-download"></i>
                            <span>本地下载</span>
                        </a>
                    </div>
                    <div class="u-data" v-if="!feed.status && cansee">
                        <div class="u-feed">
                            <Mark
                                :label="post.author"
                                :value="feed.name"
                                BGR="#f39"
                                BGL="#24292e"
                                @click.native="copy(post.author + '#' + feed.name)"
                            />
                        </div>
                        <a
                            class="u-sync"
                            v-if="isAuthor || isEditor"
                            :href="'https://pull.j3cx.com/api/dbm/feed?key=' + post.author + '-' + feed.name + '&_no_cache'"
                            target="_blank"
                            title="默认存在1分钟缓存，如需要即时生效请点击此按钮"
                        >
                            <i class="el-icon-video-play"></i> 云端同步刷新
                        </a>
                        <span class="u-desc">{{ feed.desc }}</span>
                        <a class="u-down el-button el-button--default el-button--small is-plain" :href="feed.file" target="_blank">
                            <i class="el-icon-download"></i>
                            <span>本地下载</span>
                        </a>
                    </div>
                </div>
                <div class="u-data u-data-add">
                    <div class="u-feed" v-if="meta.github">
                        <Mark :label="meta.github" value="@github" BGR="#3d454d" BGL="#24292e" @click.native="copy(meta.github + '@github')">
                            <svg class="octicon octicon-mark-github v-align-middle" height="32" viewBox="0 0 16 16" width="32" aria-hidden="true" v-bind:class="''" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill-rule="evenodd" d="M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27.68 0 1.36.09 2 .27 1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.013 8.013 0 0016 8c0-4.42-3.58-8-8-8z"/></svg>
                        </Mark>
                    </div>
                    <div class="u-feed" v-if="meta.gitee">
                        <Mark :label="meta.gitee" value="@gitee" BGR="#c71d23" BGL="#24292e" @click.native="copy(meta.gitee + '@github')">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" v-bind:class="'u-gitee'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M253.6 127.9c.3 68.8-55.8 125.7-125.3 125.7-70.1 0-125.7-56.4-125.8-125.2C2.3 60.1 55.1 2.6 127.7 2.4c72.6-.2 125.8 57.7 125.9 125.5zM112.2 198c14.5 0 29 .2 43.5 0 23.7-.3 42-18.4 42.6-42 .3-11.3.1-22.7 0-34 0-5.7-2.9-8.6-8.7-8.6-22.7-.1-45.3-.1-68 0-5.2 0-7.8 2.8-8 8.1-.1 3.5 0 7 0 10.5 0 8.4 1.9 10.2 10.3 10.3h37.5c6.3 0 8.5 2.4 8.3 8.5-.3 11.3-8.1 18.6-20.2 18.7-18 .1-36 0-54 0-7.3 0-8.9-1.6-8.9-8.8v-53c0-15.1 6.4-21.4 21.7-21.4h80c7.9 0 9.5-1.6 9.5-9.2v-11c0-6.8-1.3-8.1-8.2-8.1-27.8 0-55.6-.1-83.5 0-28 .1-48 20.2-48.1 48.2-.1 27.3 0 54.6 0 82 0 7.6 2.3 9.8 9.9 9.8 14.6.1 29.5 0 44.3 0z" fill="#fff"/></svg>
                        </Mark>
                    </div>
                    <div class="u-feed" v-if="meta.aliyun">
                        <Mark :label="meta.aliyun" value="@aliyun" BGR="#ff6a00" BGL="#24292e" @click.native="copy(meta.aliyun + '@github')">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" v-bind:class="''" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M3 127.8C3.1 58.9 59.1 3 128.1 3 196.8 3 253 59.1 253 127.4c0 69.9-55.8 125.6-125.8 125.6C58.8 252.9 2.9 196.6 3 127.8zm144.2-56c2.1 3 3.7 4.9 4.9 7.1 2.9 5.7 7.6 8.6 13.8 10.1 6.3 1.5 12.4 3.5 18.6 5.4 5.9 1.8 10 5.5 10.1 12.1.2 14.6.1 29.3-.1 43.9-.1 6.1-3.7 9.7-9.4 11.5-6.5 2.1-12.9 4.9-19.5 5.9-10.6 1.6-13.2 10.3-18.4 17.1.8.5 1 .8 1.3.8 10.5 0 21 .3 31.5 0 5.1-.1 10.3-.6 15.2-1.8 12.3-2.8 21.9-13.4 22.4-26.1.8-18.1 1.3-36.3.7-54.4-.5-16.6-8.9-26.8-23.5-30.8-2-.6-4.3-.8-6.4-.8-13.2-.1-26.7 0-41.2 0zM109 185.7c-2.6-3.9-4.7-6.7-6.4-9.6-2.5-4.3-6.1-6.7-10.9-7.9-6.7-1.7-13.3-4-20-6-7.5-2.3-10.5-6-10.6-13.7-.1-13.5-.1-27 0-40.5.1-7.5 3.4-11.7 10.6-13.8 6-1.8 12-4.2 18.2-5.2 10-1.6 13.3-9.6 18.2-16.7-.9-.3-1.4-.6-1.8-.6-12.7 0-25.3-.3-38 .1-18.7.6-30.8 13.3-31 32.1-.2 16.2-.3 32.3 0 48.5.4 19.8 11.5 30.9 29.9 33.1 13.4 1.4 27 .2 41.8.2zm-11-50.6h60.6c0-3.2-.2-6 .1-8.8.5-4.2-1.2-5.3-5.3-5.3-16.8.2-33.6.1-50.4.1-1.6 0-3.2.2-4.9.2-.1 4.9-.1 9.2-.1 13.8z" fill="#fff"/></svg>
                        </Mark>
                    </div>
                </div>
            </div>
            <div class="u-subtype-other" v-else-if="subtype != 1">
                <span class="u-typename">数据类型：{{ post_subtype }}</span>
                <a class="u-download el-button el-button--primary el-button--small" :href="meta.down | showDown" target="_blank" v-if="meta.down">
                    <i class="el-icon-download"></i>
                    <span class="u-long">默认数据下载</span>
                    <span class="u-short">下载</span>
                </a>
            </div>
        </div>
    </singlebox>
</template>

<script>
// 依赖模块
import singlebox from "@/components/cms-single";

// 本地数据
import { getPost } from "../../service/post.js";
import { getStat, postStat } from "@jx3box/jx3box-common/js/stat";
import { jx3dat_types } from "../../assets/data/types.json";
import { appKey } from "../../../setting.json";
import { getAppIcon, getAppID } from "@jx3box/jx3box-common/js/utils";


// 工具方法
import { resolveImagePath, getLink } from "@jx3box/jx3box-common/js/utils";
import User from "@jx3box/jx3box-common/js/user";

export default {
    name: "single",
    data: function() {
        return {
            loading: false,
            post: {},
            stat: {},

            meta: {},
            data : [],

            appKey,
            id: getAppID(),
        };
    },
    computed: {
        isAuthor: function() {
            return User.getInfo().uid == this.post?.post_author;
        },
        isEditor : function (){
            return User.isEditor()
        },
        subtype: function() {
            return this.post?.post_subtype;
        },
        post_subtype: function() {
            return jx3dat_types?.[this.subtype] || "-";
        },
        visible: function () {
            return this.post?._check;
        },
    },
    methods: {
        onCopy: function(val) {
            this.$notify({
                title: "订阅号复制成功",
                message: "复制内容 : " + val.text,
                type: "success",
            });
        },
        onError: function() {
            this.$notify.error({
                title: "复制失败",
                message: "请手动复制",
            });
        },
        updateExtend: function(val) {
            this.$store.state.extend = val;
        },
        copy(content) {
            console.log(content)
            navigator.clipboard
                .writeText(content)
                .then(() => {
                    this.$notify({
                        title: "复制成功",
                        message: "复制内容 : " + content,
                        type: "success",
                    });
                })
                .catch(() => {
                    this.$message({
                        message: "复制失败",
                        type: "error",
                    });
                });
        },
    },
    filters: {
        highlight: function(item) {
            const colormap = {
                newbie: "#49c10f",
                advanced: "#fba524",
                recommended: "#cb91ff",
                geek: "#fc3c3c",
            };
            if (item.mark) {
                return colormap[item.mark[0]];
            }
            return "#035cc1";
        },
        showDown: function(val) {
            return val && resolveImagePath(val);
        },
    },
    mounted: function() {
        if (this.id) {
            this.loading = true;
            getPost(this.id)
                .then((res) => {
                    this.post = this.$store.state.post = res.data.data;
                    this.$store.state.id = this.id;
                    this.$store.state.user_id = this.post?.post_author;
                    this.meta = this.post?.post_meta;
                    this.data = this.post?.post_meta?.data;

                    document.title = this.post.post_title;
                })
                .finally(() => {
                    this.loading = false;
                });

            getStat(appKey, this.id).then((res) => {
                this.stat = this.$store.state.stat = res.data;
            });
            postStat(appKey, this.id);
        }
    },
    components: {
        singlebox,
    },
};
</script>

<style lang="less">
@import "../../assets/css/single.less";
</style>
